import { style } from "@vanilla-extract/css";
import { columnStyles } from "plos/src/components/Table/tables.css";
import { breakpoints } from "plos/src/styles/breakpoints";
import { vars } from "plos/src/styles/theme.css";
import { rtlRotate180 } from "plos/src/styles/utils.css";

export const elementDialogColumnStyles = style([
  columnStyles,
  {
    width: "10%",
    textAlign: "start",
    color: vars.colors.onSurfaceVariant,
  },
]);

export const transferIconColumnStyles = style([
  columnStyles,
  {
    width: "15%",
    textAlign: "start",
    "@media": {
      [`screen and (min-width: ${breakpoints[4]})`]: {
        width: "12%",
      },
    },
  },
]);
export const elementColumnStyles = style([
  columnStyles,
  {
    width: "60%",
    textAlign: "start",
  },
]);

export const transferredColumnStyles = style([
  columnStyles,
  {
    width: "25%",
    textAlign: "end",
    color: vars.colors.onSurfaceVariant,
  },
]);

export const styledTransferArrowIcon = style([
  rtlRotate180,
  {
    verticalAlign: "middle",
    color: vars.colors.surfaceVariant,
  },
]);
